import React, { useState, useEffect } from 'react';
import { SDKProvider } from '@telegram-apps/sdk-react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import AppList from './pages/AppList';
import AppDetail from './pages/AppDetail';
import SearchPage from './components/SearchPage';
import NewsPage from './components/News/index';
import SubmitMiniAppPage from './pages/SubmitMiniAppPage';
import UserProvider from './components/UserProvider/index'; 
import AccountPage from './pages/Account';
import Loader from './components/Loader';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import './App.css';

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  // Callback to set loading to false
  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <SDKProvider acceptCustomStyles debug>
        <TonConnectUIProvider  manifestUrl="https://ton-connect.github.io/demo-dapp-with-wallet/tonconnect-manifest.json">
          <UserProvider>
            {/* {isLoading ? (
              <Loader setLoadingComplete={handleLoadingComplete} /> // Pass the callback to the Loader
            ) : ( */}
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<AppList />} />
                  <Route path="app/:id" element={<AppDetail />} />
                  <Route path="search" element={<SearchPage />} />
                  <Route path="news" element={<NewsPage />} />
                  <Route path="add-app" element={<SubmitMiniAppPage />} />
                  <Route path="account" element={<AccountPage />} />
                </Route>
              </Routes>
            {/* )} */}
          </UserProvider>
      </TonConnectUIProvider>
    </SDKProvider>
  );
};

export default App;
